module.exports = __webpack_public_path__ + "static/media/landing-image.cb19ce87.png";